'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.formatPriceTags = exports.getTallest = exports.bp = undefined;

var _setup = require('./setup.js');

var _breakpoints = require('./libs/breakpoints.js');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var bp = exports.bp = new _breakpoints2.default();

// Global UI --------------------------------------------------//
// This holds little js pieces that are global & a bit small for their own file/module

//fire event on done resizing
// const fireDoneResizing = () => {
// 	clearTimeout(doneResizeCheck);
// 	const doneResizeCheck = setTimeout(() => s.$window.trigger('nx.resize.finish'), 1000);
// };
// s.$window.on('resize', fireDoneResizing);
// s.$window.on('nx.resize.finish', () => console.log('end resize'));

// newsletter / sign-up links
// auto-scrolls user to footer signup form

//break point utilities
var runNewsletterHashCheck = function runNewsletterHashCheck() {
	var loadedHash = window.location.hash.length ? window.location.hash : false;

	if (loadedHash) {
		loadedHash = $.trim(loadedHash.replace('#', ''));

		var signupHashes = ['signup', 'sign-up', 'newsletter', 'newsletter-signup', 'newsletter-sign-up'];
		var hashIndex = signupHashes.indexOf(loadedHash);
		var onScrollComplete = function onScrollComplete() {
			return $('#newsletter-email-input').focus();
		};

		console.log(hashIndex);

		if (hashIndex > -1) {
			TweenMax.to(window, 1, {
				scrollTo: { y: _setup.s.$footer.offset().top, autoKill: false },
				onComplete: onScrollComplete
			});
		}
	}
};
_setup.s.$window.on('nx.page.loaded', function () {
	return runNewsletterHashCheck();
});

// get tallest element in a set
var getTallest = exports.getTallest = function getTallest($els) {
	var tallest = 0;
	$els.each(function () {
		var $t = $(this);
		var height = $t.outerHeight();
		if (height > tallest) tallest = height;
	});
	return tallest;
};

//format price tags
var formatPriceTags = exports.formatPriceTags = function formatPriceTags(i, item) {
	var $t = $(item);
	var price = $t.text();
	var parts = price.split('.');
	if (price.indexOf('.') === -1 || parts.length !== 2) return;

	$t.html(parts[0] + '<sup>.' + parts[1] + '</sup>');
};
if (_setup.s.$pricetags.length) {
	_setup.s.$pricetags.each(formatPriceTags);
}

//format digits
var prefixSingleDigits = function prefixSingleDigits(index, item) {
	var $this = $(item);
	$this.text(_setup.s.digitPrefixer($this.text()));
};
if (_setup.s.$prefixedDigits.length) {
	_setup.s.$prefixedDigits.each(prefixSingleDigits);
}

//pads the top of #main to make up for fixed header
var shimTheHeader = function shimTheHeader() {
	return _setup.s.$main.css({ paddingTop: _setup.s.$header.outerHeight() });
};
_setup.s.$doc.ready(shimTheHeader);
_setup.s.$window.resize($.debounce(300, shimTheHeader));

//scroll-to animated anchor links
var scrollLinkHandler = function scrollLinkHandler(e) {
	e.preventDefault();
	var $t = $(this);
	var href = $t.attr('href');
	var $target = href ? $(href) : $($t.data('scroll-to'));
	if (!$target.length) {
		console.warn('[data-scrollto] elements need a target id, from a data or href attribute');
	} else {
		var distance = _setup._s.scrollCurrent - $target.offset().top;
		var duration = distance / 1000 * 0.38;
		TweenMax.to(window, duration, { scrollTo: $target[0], ease: Expo.easeOut });
	}
};
if (_setup.s.$scrolltolinks.length) {
	_setup.s.$scrolltolinks.click(scrollLinkHandler);
}

//equal-height columns
var $eqParents = $('[data-eq-container]');
var doEqCols = function doEqCols(i, el) {
	var $this = $(el);
	var $cols = $this.find('[data-eq-col]');
	var $measures = $this.find('[data-eq-measure]');
	var breakpoint = $this.data('eq-container');

	if (bp.breakpointUp(breakpoint)) {
		$cols.css({ height: getTallest($measures) + 'px' });
	} else {
		$cols.css({ height: 'auto' });
	}
};
var eachColumnGroup = function eachColumnGroup() {
	return $eqParents.each(doEqCols);
};

if ($eqParents.length) {
	_setup.s.$doc.ready(eachColumnGroup);
	_setup.s.$window.resize($.debounce(300, eachColumnGroup));
}

//js to apply clip-path styles
var doClipPaths = function doClipPaths() {
	_setup.s.$clipEls.each(function () {
		var $t = $(this);
		var $el = $t.parent().find($t.data('clip-el'));
		var points = $t.data('clip-path');

		if (!$el.length || !points) return;

		points = points.replace(/w/g, $el.outerWidth() + 'px');
		points = points.replace(/h/g, $el.outerHeight() + 'px');
		points = points.replace(/xdiff/g, $t.width() - $el.outerWidth() + 'px');
		points = points.replace(/ydiff/g, $t.outerHeight() - $el.outerHeight() + 'px');

		$t.css({
			'clip-path': 'polygon(' + points + ')',
			'-webkit-clip-path': 'polygon(' + points + ')'
		});
	});
};

_setup.s.$window.on('nx.page.loaded', doClipPaths);
_setup.s.$window.resize($.debounce(500, doClipPaths));

//fullscreen sections
var autoHeighted = false;
var doFullscreenSection = function doFullscreenSection(index, item) {
	var $this = $(item);
	var strdim = $this.data('fullscreen-section').split('|');
	var minH = strdim[0];
	var maxH = strdim[1];
	var heroHeight = _setup._s.winHeight - _setup._s.headerHeight;

	$this.css({
		minHeight: minH + 'px',
		maxHeight: maxH + 'px',
		height: heroHeight - 30 + 'px'
	});
};
var doAutoHeightSection = function doAutoHeightSection(index, item) {
	var $this = $(item);
	if (!autoHeighted) {
		$this.attr('style', '');
		autoHeighted = true;
	}
	if ($this.hasClass('nx-homehero')) {
		var heightToSet = _setup.s.$herocarouselSlides.length ? getTallest(_setup.s.$herocarouselSlides) + 40 : $('.nx-homehero--slide').outerHeight();
		$this.css({ height: heightToSet + 'px' });
	} else {
		$this.css({ height: 'auto' });
	}
};

var fullscreenIterate = function fullscreenIterate(hasSlider) {
	//if $bp-md up
	if (bp.breakpointUp('md')) {
		_setup.s.$fullscreenSection.each(doFullscreenSection);
		if (autoHeighted) {
			autoHeighted = false;
		}
	} else {
		_setup.s.$fullscreenSection.each(doAutoHeightSection);
	}
};
_setup.s.$doc.ready(fullscreenIterate);
_setup.s.$window.resize($.debounce(200, fullscreenIterate));

//newsletter-form labels
var $newsletterInput = $('#newsletter-email-input, #promoblock-email-input');
var inputValCheck = function inputValCheck($el) {
	return !!$el.val();
};

var newsletterInputHandler = function newsletterInputHandler($t) {
	var $inputParent = $t.parent('.nx--formfield');
	return {
		keydown: function keydown() {
			if (!inputValCheck($t)) {
				$inputParent.addClass('is-filledin');
			}
		},
		keyup: function keyup() {
			if (inputValCheck($t)) {
				$inputParent.addClass('is-filledin');
			} else {
				$inputParent.removeClass('is-filledin');
			}
		},
		blur: function blur() {
			if (!inputValCheck($t)) {
				$inputParent.removeClass('is-filledin');
			}
		}
	};
};

// mailchimp submissions
var newsletterSubmitting = false;
function newsletterFormSubmit(e) {
	e.preventDefault();
	if (newsletterSubmitting) return;
	newsletterSubmitting = true;

	var $t = $(this);
	var $parent = $t.parent();
	var $email = $t.find('input[type="email"]');
	var $btn = $t.find('button[type="submit"]');
	var $msgel = $t.find('.nx--formfield-response');

	var emailval = $email.val();
	var validEmail = emailval.length > 2 && emailval.indexOf('@') > 0;
	var endpoint = $t.attr('action').replace('post?u=', 'post-json?u=') + '&c=?';

	//if not an email address
	if (!validEmail) {
		$msgel.html('<p>Please enter a valid email address.</p>');
		$parent.removeClass('is-submitting').addClass('is-submitted-invalid');
		$btn.removeAttr('disabled');
		newsletterSubmitting = false;
		return;
	}

	$parent.addClass('is-submitting').removeClass('is-submitted-invalid is-submitted-error');
	$btn.attr('disabled', true);

	//xhr callbacks
	var onAjaxSuccess = function onAjaxSuccess(data) {
		var onSuccess = function onSuccess() {
			$msgel.html('<p>' + data.msg + '</p>');
			if (data.result === 'success') {
				$parent.addClass('is-submitted-success');
			} else {
				$parent.addClass('is-submitted-error');
			}
			$parent.removeClass('is-submitting');
			$btn.removeAttr('disabled');
			newsletterSubmitting = false;
		};
		setTimeout(onSuccess, 1000);
	};
	var onAjaxError = function onAjaxError(xhr) {
		$msgel.html('<p>Something went wrong, please try again later.</p>');
		$parent.removeClass('is-submitting').addClass('is-submitted-error');
		newsletterSubmitting = false;
	};

	//submit to mailchimp
	$.ajax({
		url: endpoint,
		method: 'GET',
		dataType: 'jsonp',
		data: $t.serialize(),
		success: onAjaxSuccess,
		error: onAjaxError
	});
}

$newsletterInput.each(function () {
	$(this).on(newsletterInputHandler($(this)));
});
_setup.s.$newsletterForm.submit(newsletterFormSubmit);

//Fullwidth Sliders
var initFullwidthSliders = function initFullwidthSliders(i, item) {
	var $this = $(item);
	var $outer = $this.parent('.nx-fwslider--outer');
	var $slides = $this.find('nx-fwslider--slide');

	if ($slides.length === 1) return;

	var flkty = $this.flickity({
		cellSelector: '.nx-fwslider--slide',
		pageDots: false,
		prevNextButtons: false,
		lazyLoad: 1,
		adaptiveHeight: true
	}).data('flickity');

	var $rarr = _setup.slider.getSliderBtnHtml('Next', 'nx-fwslider-nextbtn');
	var $larr = _setup.slider.getSliderBtnHtml('Prev', 'nx-fwslider-prevbtn');
	var counter = _setup.slider.getSliderCounter(flkty);

	$rarr.click(function () {
		return _setup.s.slideNextHandler(flkty);
	});
	$larr.click(function () {
		return _setup.s.slidePrevHandler(flkty);
	});

	$this.parent().prepend($rarr, $larr, counter.html);
	$outer.find('.nx-slider--counter').prepend(counter.$current);

	flkty.on('select', function () {
		return _setup.slider.updateSliderCounter(counter.$current, flkty.selectedIndex + 1);
	});
};

if (_setup.s.$fullwidthSliders.length) {
	_setup.s.$fullwidthSliders.each(initFullwidthSliders);
}

//site-wide modal functionality
//overlay behavior
if (_setup.s.$overlaysToAppend.length) {
	_setup.s.$overlaysToAppend.each(function (i, item) {
		return $(item).detach().insertAfter(_setup.s.$footer);
	});
}

var overlayTriggerHandler = function overlayTriggerHandler(i, item) {
	var $this = $(item);
	var $overlay = $($this.data('overlay-trigger'));
	var $closebtn = $overlay.find('[data-overlay-close]');
	var overlayid = $overlay.attr('id');

	$closebtn.on('click', function () {
		TweenMax.to($overlay, 0.1, {
			autoAlpha: 0,
			onComplete: function onComplete() {
				return _setup.s.$body.removeClass('is-showing-overlay');
			},
			ease: Linear.easeNone
		});
		$overlay.trigger('nx.overlay.close');
	});

	$this.on('click', function (e) {
		e.preventDefault();
		_setup.s.$body.addClass('is-showing-overlay');
		TweenMax.to($overlay, 0.2, { autoAlpha: 1, ease: Linear.easeNone });
		$overlay.trigger('nx.overlay.open');
	});
};

if (_setup.s.$overlayTriggers.length) {
	_setup.s.$overlayTriggers.each(overlayTriggerHandler);
}

//accordion toggles
var openItemExists = false;
var setupAccordionToggles = function setupAccordionToggles(index, item) {
	var $this = $(item);
	var $titles = $this.find('[data-accordion-trigger]');

	$titles.on('click', function () {
		var $t = $(this);
		var $content = $t.next('[data-accordion-content]');
		var $parent = $t.parent('li');
		var $openPanel = $parent.siblings('.is-acc-open');

		if (!$parent.hasClass('is-acc-open')) {
			_setup.s.$body.addClass('is-acc-inuse');

			TweenMax.set($content, { height: 'auto' });
			TweenMax.from($content, 0.5, { height: 0, ease: Expo.easeOut });

			if ($openPanel.length) {
				TweenMax.to($openPanel.find('[data-accordion-content]'), 0.5, { height: 0, ease: Expo.easeOut });
				$openPanel.removeClass('is-acc-open');
			}

			$parent.addClass('is-acc-open');
		} else {
			TweenMax.to($content, 0.5, {
				height: 0,
				ease: Expo.easeOut,
				onComplete: function onComplete() {
					return _setup.s.$body.removeClass('is-acc-inuse');
				}
			});
			$parent.removeClass('is-acc-open');
		}
	});
};

if (_setup.s.$accordions.length) {
	_setup.s.$accordions.each(setupAccordionToggles);
}

// Fullwidth Product Promo --------------------------------------------------//
var fullwidthProductPromo = function fullwidthProductPromo(i, item) {
	var $this = $(item);
	var $btn = $this.find('.nx-fwpromo--toggle');
	var $btnOuter = $btn.parent('.nx-fwpromo--plus');
	var $panel = $this.find('.nx-fwpromo--panel');
	var $bg = $this.find('.nx--img-cover');

	$btn.on('click', function (e) {
		e.preventDefault();
		if ($btnOuter.hasClass('is-animating')) return;
		$btnOuter.addClass('is-animating');

		if (!$this.hasClass('is-openpromo')) {
			//panel edge destination
			var panelLeftEdge = $btn.offset().left - ($panel.offset().left - $panel.width()) + $btn.width() / 2;

			TweenMax.to($btnOuter, 0.5, { x: -(panelLeftEdge - 1), rotation: 45, ease: Expo.easeOut, delay: 0.1 });
			TweenMax.to($panel, 0.6, { x: '0%', ease: Expo.easeOut });
			TweenMax.to($bg, 0.6, {
				x: '-10%',
				ease: Expo.easeOut,
				onComplete: function onComplete() {
					return $btnOuter.removeClass('is-animating');
				}
			});

			$this.addClass('is-openpromo');
		} else {
			TweenMax.to($btnOuter, 0.3, { x: 0, rotation: 0, ease: Expo.easeOut });
			TweenMax.to($panel, 0.3, { x: '100%', ease: Expo.easeOut });
			TweenMax.to($bg, 0.3, {
				x: '0%',
				ease: Expo.easeOut,
				onComplete: function onComplete() {
					return $btnOuter.removeClass('is-animating');
				}
			});

			$this.removeClass('is-openpromo');
		}
	});
};

if (_setup.s.$productFullwidthPromo.length) {
	_setup.s.$productFullwidthPromo.each(fullwidthProductPromo);
}

//recipe promo (ingredients list)
//shortening client side
var $promoIngrList = $('.nx-recipepromo--ingr-ul');
var shortenIngrList = function shortenIngrList() {
	var $ul = $promoIngrList.find('ul');
	var $li = $ul.find('li');
	var moreText = $promoIngrList.data('more-text');
	$promoIngrList.find('br').remove();
	$li.slice(4).remove();
	if (moreText) {
		$ul.append('<li>' + moreText + '</li>');
	}
};
if ($promoIngrList.length) {
	shortenIngrList();
}

// read more bars - setting size of hr
var setReadmoreBarSize = function setReadmoreBarSize(index, item) {
	if (!bp.breakpointUp('md')) return;
	var $this = $(item);
	var $title = $this.find('.nx-morebar--title');
	var $hr = $this.find('.nx-morebar--dash');
	var $btn = $this.find('.nx-morebar--viewall');

	$hr.css({ left: $title.width() + 25 + 'px', right: $btn.width() + 25 + 'px', width: 'auto' });
};
var readmoreBarsIterate = function readmoreBarsIterate() {
	return _setup.s.$readmoreBars.each(setReadmoreBarSize);
};

if (_setup.s.$readmoreBars.length) {
	_setup.s.$window.on('nx.page.loaded', readmoreBarsIterate);
	_setup.s.$window.resize($.debounce(700, readmoreBarsIterate));
}

// add class to hide bottom page flame
var watchBodyHeight = function watchBodyHeight() {
	if (_setup.s.$body.height() < 5200) {
		_setup.s.$body.addClass('is-shortpage');
	} else if (_setup.s.$body.hasClass('is-shortpage')) {
		_setup.s.$body.removeClass('is-shortpage');
	}
};
window.setInterval(watchBodyHeight, 500);

// tweet block
var getTweet = function getTweet() {
	var donecb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	var errcb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var $tweetText = $('.nx-socialblock--tweettext');
	$.ajax({
		url: 'https://mag-tweet-fetcher.herokuapp.com/api/get_tweet',
		method: 'POST',
		data: {
			screen_name: 'nexgrill_ind'
		},
		success: function success(data) {
			if (data.errors) {} else {
				//console.log(data);
				$tweetText.html(data.tweet);
			}
		},
		error: function error(xhr) {
			console.log(xhr);
		}
	});
};

if (_setup.s.$tweetBlock.length) {
	_setup.s.$window.on('nx.page.loaded', function () {
		return setTimeout(function () {
			return getTweet();
		}, 700);
	});
}

//Social share buttons
function doSocialShare(event) {
	event.preventDefault();

	var $this = $(this);
	var shareurl = $this.attr('href');

	//for addthis analytics
	if (window.magtheme.addThisPubID) {
		shareurl = shareurl + '&pubid=' + window.magtheme.addThisPubID;
	}

	$.centeredPopup({
		url: $this.attr('href'),
		width: 500,
		height: 400
	});
}

if (_setup.s.$socialShareLinks.length) {
	_setup.s.$socialShareLinks.click(doSocialShare);
}

//footer link lists
var $footerNavs = _setup.s.$footer.find('.nx-footer--navs > ul > li');

var footerNavEach = function footerNavEach(i, item) {
	var $this = $(item);
	var $title = $this.find('h5');
	var $list = $this.find('ul');
	var $listItems = $list.find('li');
	var isOpen = false;

	$title.on('click', function () {
		if (bp.breakpointUp('md')) return;
		if (!isOpen) {
			TweenMax.set($list, { height: 'auto' });
			TweenMax.set($listItems, { autoAlpha: 0 });
			TweenMax.from($list, 0.25, { height: 0, ease: Expo.easeOut });
			TweenMax.staggerFromTo($listItems, 0.8, { y: -10, autoAlpha: 0 }, { y: 0, autoAlpha: 1, ease: Expo.easeOut }, 0.075);
			$this.addClass('is-nav-open');
			isOpen = true;
		} else {
			TweenMax.to($list, 0.2, { height: 0, ease: Expo.easeOut });
			$this.removeClass('is-nav-open');
			isOpen = false;
		}
	});
};
var footerNavsHandler = function footerNavsHandler() {
	if ($footerNavs.length) {
		$footerNavs.each(footerNavEach);
	}
};
_setup.s.$doc.ready(footerNavsHandler);

//print buttons
if (_setup.s.$printBtns.length) {
	_setup.s.$printBtns.on('click', function () {
		return window.print();
	});
}

// Cleanup RTE Content
//-------------------------------------------------------------//

var unwrapNested = function unwrapNested($element) {
	var $parent = $element.parent();

	while ($parent.length && !$parent.hasClass('nx-rte-content')) {
		$element.unwrap();
		$parent = $element.parent();
	}
};

var rteCleanup = function rteCleanup(index, item) {
	var $this = $(item);
	var $iframes = $this.find('iframe');
	var isBlog = $this.hasClass('nx-blogbody--content');

	$this.find('br, meta').remove();
	$this.children().find('span[style]').contents().unwrap();

	//ensure heading formats
	$this.find('h1,h2,h3,h4,h5,h6').each(function (i, item) {
		var $h = $(item);
		var text = $h.text();
		$h.html('').text(text);
	});

	//floated images
	$this.find('img').each(function (i, item) {
		var $img = $(item);
		//unwrapNested($img);
	});

	//fluid iframes
	$this.find('iframe[src*="youtube"], iframe[src*="vimeo"]').each(function (i, item) {
		var $f = $(item);
		unwrapNested($f);
		var pb = $f.attr('height') / $f.attr('width') * 100;
		$f.wrap('<div style="position:relative;overflow:hidden;height:0;padding-bottom:' + pb + '%;"></div>').css({ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' });
		$f.parent().wrap('<div class="nx-rte-iframe"></div>');
	});
};

if (_setup.s.$rtecontent.length) {
	_setup.s.$rtecontent.each(rteCleanup);
}

// Seasonal Promo Pages (NFL) -----------------------------------------------//

var pageType = _setup.s.$body.data('shopify-template');

var $bbgrill = null;
var lerped = 0;

var doImageMove = function doImageMove() {
	var offset = $bbgrill.offset();
	var wintop = window.pageYOffset;
	var winheight = $(window).height();
	var scrollenter = wintop + winheight;
	var xpos = (scrollenter - offset.top) * 0.0333;
	lerped += (xpos - lerped) * 0.1;
	if (scrollenter >= offset.top) {
		TweenMax.set($bbgrill, { x: lerped });
	}
	requestAnimationFrame(doImageMove);
};

var seasonalPromoTemplate = function seasonalPromoTemplate() {
	var $grillImg = $('.nx--grillimg-cover'),
	    $socialImg = $('.nx-socialblock--smimg');
	var grillSrc = $grillImg.css('background-image');
	grillSrc = grillSrc.replace('url("', '');
	grillSrc = grillSrc.replace('")', '');
	var $newImg = $('<img class="overlapped-grill" />');
	$newImg.attr({ src: grillSrc }).css({ marginLeft: '-5.5%' });
	$socialImg.append($newImg);
	$bbgrill = $socialImg.find('.overlapped-grill');
	setTimeout(function () {
		return doImageMove();
	}, 300);
};

if (pageType === 'page.jaguars') {
	_setup.s.$doc.ready(function () {
		return seasonalPromoTemplate();
	});
}
/**
 * NG_6_W20_0001 - Issue with Sub-Headers
 * 
 * Card titles under Products & Explore aren't getting
 * clip-path'd on Edge (non chromium). In this case,
 * append a parent div around the span so that it can
 * get a pseudo element under it that gets a white bg.
 */
_setup.s.$doc.ready(function () {
	if (window.navigator.userAgent.indexOf('Edge') > -1) {
		document.body.classList.add('is-edge');
	} else {
		return;
	}

	var $threeUp = function $threeUp() {
		return $('.is-edge .nx--imglink-list figcaption');
	};
	var $twoUp = function $twoUp() {
		return $('.is-edge .nx-imgpair figcaption');
	};

	function appendDiv() {
		var $t = $(this);

		$t.append('<div></div>');

		var $newParent = $t.find('div');
		var $child = $t.find('span').detach();
		$newParent.append($child);
	}

	$threeUp().each(appendDiv);
	$twoUp().each(appendDiv);
});


//////////////////
// WEBPACK FOOTER
// ./_js/global-ui.js
// module id = 2
// module chunks = 0